(() => {
  const config = document.getElementById('taishan-tax-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const escape = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  window.taishanFormatPrice = (amount, taxable) => {
    const format = window.T4SThemeSP.Currency.formatMoney;
    const net = taxable === false ? amount : Math.round(amount / 1.2);
    return '<span class="taishan-dual-price"><span class="taishan-price-gross">' + format(amount) + ' <span class="taishan-tax-label">' + escape(labels.gross) + '</span></span><small class="taishan-price-net">' + format(net) + ' ' + escape(labels.net) + '</small></span>';
  };
})();
